import { useLayoutEffect, useState, type RefCallback } from 'react'
import { isDefined, isNotDefined } from '@terros/common'
import { isContainerAtLeast } from './useContainerBreakpoint'

export type ParentRoom = {
  ref: RefCallback<HTMLElement>
  hasRoom: boolean
}

export const useParentHasRoom = (minWidth: number): ParentRoom => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const [hasRoom, setHasRoom] = useState(true)

  useLayoutEffect(() => {
    const parent = element?.parentElement
    if (isNotDefined(parent)) {
      setHasRoom(true)
      return
    }
    setHasRoom(isContainerAtLeast(parent.getBoundingClientRect().width, minWidth))

    const observer = new ResizeObserver((entries) => {
      const entry = entries.at(0)
      if (isDefined(entry)) setHasRoom(isContainerAtLeast(entry.contentRect.width, minWidth))
    })
    observer.observe(parent)
    return () => observer.disconnect()
  }, [element, minWidth])

  return { ref: setElement, hasRoom }
}
